/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-09 14:24:03
 */
const TrainingObjectManage = () => {
  return <p>TrainingObjectManage</p>;
};

export default TrainingObjectManage;
